export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10194.a80d60fc.jpg";